<template>
  <!-- 플랫폼 페이지에 있는 커스텀 컨테이너 -->
  <b-row align-h="center" class="px-3">
    <b-col cols="12" md="11" xl="9">
      <slot />
    </b-col>
  </b-row>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
